import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IContentLibraryIndirectTaxFrequenciesParams,
  IContentLibraryResponse,
} from './types';

// Hook to fetch indirect tax frequencies from Content Library
// Returns available filing frequencies for a specific jurisdiction + tax type

export function useContentLibraryIndirectTaxFrequencies(
  params: IContentLibraryIndirectTaxFrequenciesParams | null,
  token?: string
) {
  const shouldFetch =
    params?.corporationId && params?.jurisdictionId && params?.taxType;

  const { data, mutate, error, isLoading } = useSWR<IContentLibraryResponse>(
    shouldFetch
      ? [
          'content-library/indirect-tax-frequencies',
          params.corporationId,
          params.jurisdictionId,
          params.taxType,
        ]
      : null,
    async () => {
      const response = await fetcher(
        'content-library/indirect-tax-frequencies',
        { method: 'POST', body: params },
        token
      );
      if (!response.ok) {
        throw new Error('Failed to fetch indirect tax frequencies');
      }
      return response.json();
    }
  );

  return {
    data,
    options: data?.options || [],
    mutate,
    error,
    isLoading,
  };
}
